<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import LetterTile from './LetterTile.svelte';
  import type { LetterState } from './types';

  export let letterStates: Record<string, LetterState> = {};
  export let disabled: boolean = false;

  const dispatch = createEventDispatcher();

  const QWERTY_ROWS = [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
  ];

  function handleSelect(event: CustomEvent<string>) {
    dispatch('guess', event.detail);
  }
</script>

<div class="keyboard" role="group" aria-label="On-screen keyboard">
  {#each QWERTY_ROWS as row}
    <div class="keyboard-row">
      {#each row as letter}
        <LetterTile
          {letter}
          state={letterStates[letter] || 'unused'}
          {disabled}
          size="small"
          on:select={handleSelect}
        />
      {/each}
    </div>
  {/each}
</div>

<style>
  .keyboard {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 10px;
  }

  .keyboard-row {
    display: flex;
    gap: 4px;
    justify-content: center;
  }
</style>
